<template>
  <div class="website-details">
    <v-container>
      <v-stepper vertical flat v-model="websiteStepper" class="mb-16">
        <v-stepper-items>
          <!-- first stepper for corporate information  -->
          <v-stepper-step
            :complete="websiteStepper > 1"
            step="1"
            :rules="[() => this.websiteApplicationError]"
            color="#434343"
          >
            Website Details
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-container>
              <v-form ref="formWebApplication">
                <v-row class="ma-0">
                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">Merchant's Website <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="website_application_form.merchant_website"
                      :rules="websiteRules"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Merchant's Website"
                      label=""
                      dense
                      name="websitedetails_merchant_website"
                      id="websitedetails_merchant_website"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">Type of Bussiness <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="website_application_form.business_type"
                      :rules="TextRules"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Type of Bussiness"
                      label=""
                      dense
                      name="websitedetails_business_type"
                      id="websitedetails_business_type"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <label for="">Descriptor</label>
                    <v-text-field
                      v-model="website_application_form.descriptor"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Descriptor"
                      label=""
                      dense
                      name="websitedetails_descriptor"
                      id="websitedetails_descriptor"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <small>MERCHANT NAME TO APPEAR ON CREDIT CARD</small>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <label for="">IP Address</label>
                    <v-text-field
                      v-model="website_application_form.ip_address"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter IP Address"
                      dense
                      name="websitedetails_ip_address"
                      id="websitedetails_ip_address"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <label for="">City Name</label>
                    <v-text-field
                      v-model="website_application_form.city"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter City Name"
                      label=""
                      dense
                      name="websitedetails_city_field"
                      id="websitedetails_city_field"
                    >
                      <!-- <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <small>CUSTOMER SERVICE PHONE NUMBER</small>
                        </v-tooltip>
                      </template> -->
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">Customer Support Email <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="website_application_form.customer_support_email"
                      :rules="emailRules"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter ustomer Support Email"
                      label=""
                      dense
                      name="websitedetails_customer_support_email"
                      id="websitedetails_customer_support_email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">Charge Back Notification Email <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="
                        website_application_form.chargeback_notification_email
                      "
                      :rules="emailRules"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Charge Back Notification Email"
                      label=""
                      dense
                      name="websitedetails_chargeback_notification_email"
                      id="websitedetails_chargeback_notification_email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">How Long Have You Been In Business <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="website_application_form.business_time_period"
                      :rules="TextRules"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter How Long Have You Been In Business"
                      label=""
                      dense
                      name="websitedetails_business_duration"
                      id="websitedetails_business_duration"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <label for=""
                      >Previous/Current Name of Processor or Acquirer</label
                    >
                    <v-text-field
                      v-model="website_application_form.processor_name"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Previous/Current Name of Processor or Acquirer"
                      label=""
                      dense
                      name="websitedetails_business_acquirer"
                      id="websitedetails_business_acquirer"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <label for="">Current Monthly Sales Volume</label>
                    <v-text-field
                      v-model="website_application_form.monthly_sales_volume"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Current Monthly Sales Volume"
                      label=""
                      dense
                      type="number"
                      name="websitedetails_monthly_sales"
                      id="websitedetails_monthly_sales"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <label for="">Number of Monthly Transactions</label>
                    <v-text-field
                      v-model="website_application_form.monthly_transaction"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Number of Monthly Transactions"
                      label=""
                      dense
                      type="number"
                      name="websitedetails_monthly_transactions"
                      id="websitedetails_monthly_transactions"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"
                    ><h5 style="color: #434343">
                      Desired Processing Currencies
                    </h5></v-col
                  >
                  <v-col cols="2" class="mt-4">
                    <v-checkbox
                      v-model="website_application_form.processing_currency.eur"
                      :label="`EUR`"
                      color="#434343"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="2" class="mt-4">
                    <v-checkbox
                      v-model="website_application_form.processing_currency.usd"
                      :label="`USD`"
                      color="#434343"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="2" class="mt-4">
                    <v-checkbox
                      v-model="website_application_form.processing_currency.gbp"
                      :label="`GBP`"
                      color="#434343"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6">
                    <label for="">Other</label>
                    <v-text-field
                      v-model="
                        website_application_form.processing_currency.other
                      "
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Other"
                      label=""
                      dense
                      name="websitedetails_other_processing_countries"
                      id="websitedetails_other_processing_countries"
                    ></v-text-field>
                    <blockquote style="margin-top: -28px; line-height:1">
                      <small style="font-size: 11px;" class="grey--text">
                        Use a comma ( , ) separator to add more than one desired
                        processing currencies
                      </small>
                    </blockquote>
                  </v-col>

                  <v-col cols="12"
                    ><h5 style="color: #434343">
                      Desired Settlement Currencies
                    </h5></v-col
                  >
                  <v-col cols="2" class="mt-4">
                    <v-checkbox
                      v-model="website_application_form.settlement_currency.eur"
                      :label="`EUR`"
                      color="#434343"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="2" class="mt-4">
                    <v-checkbox
                      v-model="website_application_form.settlement_currency.usd"
                      :label="`USD`"
                      color="#434343"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="2" class="mt-4">
                    <v-checkbox
                      v-model="website_application_form.settlement_currency.gbp"
                      :label="`GBP`"
                      color="#434343"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6">
                    <label for="">Other</label>
                    <v-text-field
                      v-model="
                        website_application_form.settlement_currency.other
                      "
                      color="#434343"
                      outlined
                      placeholder="Enter Other"
                      label=""
                      maxlength="51"
                      dense
                      name="websitedetails_other_settlement_countries"
                      id="websitedetails_other_settlement_countries"
                    ></v-text-field>
                    <blockquote style="margin-top: -28px; line-height:1">
                      <small style="font-size: 11px;" class="grey--text">
                        Use a comma ( , ) separator to add more than one desired
                        settlement currencies
                      </small>
                    </blockquote>
                  </v-col>
                  <v-col cols="6" class="mt-6">
                    <v-checkbox
                      v-model="website_application_form.is_payment_by_card"
                      :label="
                        `Do You Use Payment Methods Other Than Credit Cards`
                      "
                      color="#434343"
                      class="mt-1"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6">
                    <label for="">Other</label>
                    <v-text-field
                      v-model="website_application_form.other_payment"
                      maxlength="51"
                      color="#434343"
                      outlined
                      placeholder="Enter Other"
                      label=""
                      dense
                      name="websitedetails_other_payments_than_credit_card"
                      id="websitedetails_other_payments_than_credit_card"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <small
                            >IF YOU USE PAYMENT METHODS OTHER THAN CARD!<br />(PLEASE
                            SPECIFY)</small
                          >
                        </v-tooltip>
                      </template></v-text-field
                    >
                    <blockquote style="margin-top: -28px; line-height:1">
                      <small style="font-size: 11px;" class="grey--text">
                        If yes, then mention the payment method here
                      </small>
                    </blockquote>
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox
                      v-model="website_application_form.preauthorize_trx"
                      :label="`Do You Pre-authorize Card Transactions`"
                      color="#434343"
                      class="mt-1"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-btn
              color="#434343"
              dark
              @click="updateWebsiteDetails()"
              class="float-end mb-2"
              >Next</v-btn
            >
          </v-stepper-content>
          <!-- second vertical stepper -->
          <v-stepper-step
            :complete="websiteStepper > 2"
            :rules="[() => this.webContentError]"
            step="2"
            color="#434343"
          >
            Website Content
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-form ref="formWebContent">
                <v-row class="ma-0">
                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">Products or Services Sold <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="website_content_form.service_product"
                      :rules="TextRules"
                      color="#434343"
                      outlined
                      placeholder="Enter Products or Services Sold"
                      label=""
                      dense
                      name="websitedetails_product_details"
                      id="websitedetails_product_details"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <small
                            >WHAT ARE THE PRODUCTS OR SERVICES SOLD<br />ON YOUR
                            WEBSITE?</small
                          >
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">Payment Model <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="website_content_form.payment_model"
                      :rules="TextRules"
                      color="#434343"
                      outlined
                      placeholder="Enter Payment Model"
                      label=""
                      dense
                      name="websitedetails_payment_model"
                      id="websitedetails_payment_model"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <small
                            >PLEASE SPECIFY THE PAYMENT MODEL<br />(RECURRING,
                            ONE-TIME PAYMENT, PAYMENT PER MINUTE)</small
                          >
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">When Customer is charged? <span class="red--text"><strong>* </strong></span></label>
                    <v-text-field
                      v-model="website_content_form.customer_charged_time"
                      :rules="TextRules"
                      color="#434343"
                      outlined
                      placeholder="Enter Customer Charged"
                      label=""
                      dense
                      name="websitedetails_customer_charged"
                      id="websitedetails_customer_charged"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <small
                            >WHEN CUSTOMER IS CHARGED FOR PLACING ORDER<br />(UPON
                            PLACING ORDER, WHEN ORDER IS SHIPPED, UPON
                            RECIEPT)</small
                          >
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <!-- <span class="red--text"><strong>* </strong></span> -->
                    <label for="">Major Countries of Customers <span class="red--text"><strong>* </strong></span></label>
                    <v-combobox
                      v-model="website_content_form.customer_countries"
                      :items="items"
                      chips
                      clearable
                    :rules="TextRules"
              append-icon="mdi-abc"

                      label=""
                      multiple
                      outlined
                      placeholder="Enter Major Countries of Customers"
                      color="#434343"
                    >
                      <template
                        v-slot:selection="{
                          attrs,
                          item,
                          select,
                          selected,
                          index,
                        }"
                      >
                        <v-chip
                          v-bind="attrs"
                          class="my-1 mt-2"
                          :input-value="selected"
                          close
                          @click="select"
                          @click:close="
                            website_content_form.customer_countries.splice(
                              index,
                              1
                            )
                          "
                          small
                        >
                          <strong>{{ item }}</strong
                          >&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                    <blockquote style="text-align: end; margin-top: -26px;">
                      <small style="font-size: 11px;" class="grey--text"
                        >Press the enter or tab button to proceed with the
                        enlistings of the major countries of customers</small
                      >
                    </blockquote>
                  </v-col>
                  <v-col cols="6" class="mt-8">
                    <v-checkbox
                      v-model="website_content_form.direct_order"
                      :label="`Does your company fulfill orders directly?`"
                      color="#434343"
                      class="mt-1"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6">
                    <label for="">Other</label>
                    <v-text-field
                      v-model="website_content_form.company_fulfill_order"
                      color="#434343"
                      outlined
                      placeholder="Enter Other"
                      label=""
                      dense
                      name="websitedetails_other_orders_fullfillment"
                      id="websitedetails_other_orders_fullfillment"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <small
                            >IF YOUR COMAPNY DOESN'T FULLFILL ORDERS
                            DIRECTLY!<br />PLEASE PROVIDE FULFILLMENT COMAPANY
                            INFORMATION DETAILS</small
                          >
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    <blockquote style="margin-top: -28px; line-height:1">
                      <small style="font-size: 11px;" class="grey--text">
                        Mention yes or no as per your experience
                      </small>
                    </blockquote>
                  </v-col>
                  <v-col cols="6" class="mt-1">
                    <v-checkbox
                      v-model="website_content_form.email_recipient_cardholder"
                      :label="
                        `Do you send email reciept to the cardholder, when product is fulfilled.`
                      "
                      color="#434343"
                      class="mt-1"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox
                      v-model="website_content_form.services_offered"
                      :label="
                        `Do you distribute any materials or agreements to customers, related to services Offered.`
                      "
                      color="#434343"
                      class="mt-1"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-btn text @click="websiteStepper = 1" class=" adjust-pre-btn float-end mb-2 mr-5"
              >Previous</v-btn
            >
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-btn
        color="#434343"
        dark
        class="mr-2 float-end"
        @click="updateWebsiteContent()"
        >Next</v-btn
      >
      <v-btn text @click="updateIndex(3)" class="float-end adjust-pre-btn mr-1">
        Previous
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "WebsiteDetails",
  data() {
    return {
      search: "",
      key: null,
      websiteApplicationError: !this.$store.state.websiteDetailsError,
      webContentError: !this.$store.state.websiteContentError,
      TextRules: [(v) => !!v || "Required"],
      websiteStepper: 1,
      websiteRules: [
        v => v.length > 0 || "Required",
        v => !!v || "Website is Required",
        v => /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm.test(v) ||
          // /(^http[s]?:\/{2})|(^www.)|(^\/{1,2})/.test(v) ||
          "Pattern should be like website"
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      chips: [],
      items: [],

      website_application_form: {
        merchant_website: "",
        business_type: "",
        ip_address: "",
        descriptor: "",
        customer_support_email: "",
        city: "",
        chargeback_notification_email: "",
        business_time_period: "",
        processor_name: "",
        monthly_sales_volume: "",
        monthly_transaction: "",
        processing_currency: {
          eur: false,
          usd: false,
          gbp: false,
          other: "",
        },
        settlement_currency: {
          eur: false,
          usd: false,
          gbp: false,
          other: "",
        },
        is_payment_by_card: false,
        other_payment: "",
        preauthorize_trx: false,
      },

      website_content_form: {
        service_product: "",
        payment_model: "",
        customer_charged_time: "",
        customer_countries: [],
        direct_order: false,
        company_fulfill_order: "",
        email_recipient_cardholder: false,
        services_offered: false,
      },
    };
  },
  computed: {
    ...mapGetters(["getWebAppID", "getWebContentID", "getUserId", "getFormId"]),
  },
  methods: {
    updateItems() {
      if (this.search !== null && this.search !== "") {
        this.$nextTick(() => {
          this.business_primary_contact_details.companies_and_websites.push(
            ...this.search.split(",")
          );
          this.$nextTick(() => {
            this.search = "";
          });
        });
      }
    },
    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    },
    remove(item) {
      this.website_content_form.customer_countries.splice(
        this.website_content_form.customer_countries.indexOf(item),
        1
      );
    },
    updateWebsiteDetails() {
      if (!this.$refs.formWebApplication.validate()) {
        this.$store.dispatch("updateWebsiteDetailsError", true);
        this.websiteApplicationError = !true;
      } else {
        this.$store.dispatch("updateWebsiteDetailsError", !true);
        this.websiteApplicationError = true;
      }
      axios
        .post(
          "/createWebsiteApplicationForm",
          {
            user_id: this.getUserId,
            form_id: this.getFormId,
            website_application_form_id: this.getWebAppID,
            website_application_form: this.website_application_form,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          // console.log(res.data, "web app added", this.website_application_form);
        })
        .catch((err) => {
          console.log(err, "web app error");
        });

      this.websiteStepper = 2;
      // console.log(this.website_application_form.processing_currency, "Proce");
    },
    updateWebsiteContent() {
      if (!this.$refs.formWebContent.validate()) {
        this.$store.dispatch("updateWebsiteContentError", true);
        this.webContentError = !true;
      } else {
        this.$store.dispatch("updateWebsiteContentError", !true);
        this.webContentError = true;
      }
      axios
        .post(
          "/createWebContentForm",
          {
            user_id: this.getUserId,
            form_id: this.getFormId,
            web_content_form_id: this.getWebContentID,
            web_content_form: this.website_content_form,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          // console.log(res.data, "web content");
        })
        .catch((err) => {
          console.log(err, "web content er");
        });
      this.updateIndex(5);
      this.$store.dispatch("incrementStepper");
    },
  },
  mounted() {
    // get web app form data
    // axios
    //   .post(
    //     "/websiteApplication",
    //     {
    //       user_id: this.getUserId,
    //       form_id: this.getFormId,
    //     },
    //     {
    //       headers: {
    //         Authorization: "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     // console.log(res.data, "web app");
    //     var processing_currency =
    //       res.data.websiteApplication.processing_currency == ""
    //         ? ""
    //         : JSON.parse(res.data.websiteApplication.processing_currency);
    //     var settlement_currency =
    //       res.data.websiteApplication.settlement_currency == ""
    //         ? ""
    //         : JSON.parse(res.data.websiteApplication.settlement_currency);
    //     console.log(settlement_currency.usd == true ? true : false, ">>>>");
    //     this.website_application_form.merchant_website =
    //       res.data.websiteApplication.merchant_website == null
    //         ? ""
    //         : res.data.websiteApplication.merchant_website;
    //     this.website_application_form.business_type =
    //       res.data.websiteApplication.business_type == null
    //         ? ""
    //         : res.data.websiteApplication.business_type;
    //     this.website_application_form.descriptor =
    //       res.data.websiteApplication.descriptor == null
    //         ? ""
    //         : res.data.websiteApplication.descriptor;
    //     this.website_application_form.ip_address =
    //       res.data.websiteApplication.ip_address == null
    //         ? ""
    //         : res.data.websiteApplication.ip_address;
    //     this.website_application_form.city =
    //       res.data.websiteApplication.city == null
    //         ? ""
    //         : res.data.websiteApplication.city;
    //     this.website_application_form.customer_support_email =
    //       res.data.websiteApplication.customer_support_email == null
    //         ? ""
    //         : res.data.websiteApplication.customer_support_email;
    //     this.website_application_form.chargeback_notification_email =
    //       res.data.websiteApplication.chargeback_notification_email == null
    //         ? ""
    //         : res.data.websiteApplication.chargeback_notification_email;
    //     this.website_application_form.business_time_period =
    //       res.data.websiteApplication.business_time_period == null
    //         ? ""
    //         : res.data.websiteApplication.business_time_period;
    //     this.website_application_form.processor_name =
    //       res.data.websiteApplication.processor_name == null
    //         ? ""
    //         : res.data.websiteApplication.processor_name;
    //     this.website_application_form.monthly_sales_volume =
    //       res.data.websiteApplication.monthly_sales_volume == null
    //         ? ""
    //         : res.data.websiteApplication.monthly_sales_volume;
    //     this.website_application_form.monthly_transaction =
    //       res.data.websiteApplication.monthly_transaction == null
    //         ? ""
    //         : res.data.websiteApplication.monthly_transaction;
    //     this.website_application_form.processing_currency.eur =
    //       processing_currency.eur == true ? true : false;
    //     this.website_application_form.processing_currency.usd =
    //       processing_currency.usd == true ? true : false;
    //     this.website_application_form.processing_currency.gbp =
    //       processing_currency.gbp == true ? true : false;
    //     this.website_application_form.processing_currency.other =
    //       processing_currency.other == null || processing_currency.other == ""
    //         ? ""
    //         : processing_currency.other;

    //     this.website_application_form.settlement_currency.eur =
    //       settlement_currency.eur == true ? true : false;
    //     this.website_application_form.settlement_currency.usd =
    //       settlement_currency.usd == true ? true : false;
    //     this.website_application_form.settlement_currency.gbp =
    //       settlement_currency.gbp == true ? true : false;
    //     this.website_application_form.settlement_currency.other =
    //       settlement_currency.other == null || settlement_currency.other == ""
    //         ? ""
    //         : settlement_currency.other;

    //     this.website_application_form.preauthorize_trx =
    //       res.data.websiteApplication.preauthorize_trx == 0 ? false : true;
    //     this.website_application_form.is_payment_by_card =
    //       res.data.websiteApplication.is_payment_by_card == 0 ? false : true;
    //     this.website_application_form.other_payment =
    //       res.data.websiteApplication.other_payment == null
    //         ? ""
    //         : res.data.websiteApplication.other_payment;
    //   })
    //   .catch((err) => {
    //     console.log(err, "web app err");
    //   });

    // get web content data
    // axios
    //   .post(
    //     "/webContent",
    //     {
    //       user_id: this.getUserId,
    //       form_id: this.getFormId,
    //     },
    //     {
    //       headers: {
    //         Authorization: "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     // console.log(res.data, "web con");
    //     this.website_content_form.service_product =
    //       res.data.getWebContent.service_product == null
    //         ? ""
    //         : res.data.getWebContent.service_product;
    //     this.website_content_form.payment_model =
    //       res.data.getWebContent.payment_model == null
    //         ? ""
    //         : res.data.getWebContent.payment_model;
    //     this.website_content_form.customer_charged_time =
    //       res.data.getWebContent.customer_charged_time == null
    //         ? ""
    //         : res.data.getWebContent.customer_charged_time;
    //     if (res.data.getWebContent.customers_country == "") {
    //       this.website_content_form.customer_countries = "";
    //     } else {
    //       JSON.parse(res.data.getWebContent.customers_country).filter(
    //         (country) => {
    //           this.website_content_form.customer_countries.push(country);
    //         }
    //       );
    //     }
    //     this.website_content_form.direct_order =
    //       res.data.getWebContent.direct_order == 0 ? false : true;
    //     this.website_content_form.company_fulfill_order =
    //       res.data.getWebContent.company_fulfill_order == null
    //         ? ""
    //         : res.data.getWebContent.company_fulfill_order;
    //     this.website_content_form.email_recipient_cardholder =
    //       res.data.getWebContent.email_recipient_cardholder == 0 ? false : true;
    //     this.website_content_form.services_offered =
    //       res.data.getWebContent.services_offered == 0 ? false : true;
    //   })
    //   .catch((err) => {
    //     console.log(err, "web cont err");
    //   });
    this.TextRules.push((v) => v.length <= 50 || "Max 50 characters");
  },
};
</script>
<style scoped>
.adjust-pre-btn {
font-size: 11px !important;
}
</style>